// Get locale from path
export const getUrlLocale = (): string => {
  if (typeof window === 'undefined') return 'en'
  else if (window.location.pathname.includes('redirect')) return 'en'
  else return window.location.pathname.split('/')[1]
}
